import React, { Component } from 'react'; //this is a library/module does not require full path
import ReactDOM from 'react-dom'; //this is a library/module does not require full path
import YTSearch from 'youtube-api-search';
// These are NOT libraries/modules so they require a full path
import VideoList from '../video_list';
import VideoDetail from '../video_detail';

const API_KEY = 'AIzaSyAzIO8qq8WkTqYhtmf1Va9ObmWxfGGGbN0';

class VideoPlayer extends Component {
	constructor(props) {
		super(props);
	
		this.state = { 
			videos: [],
			selectedVideo: null
		};

		const videoIds = 'yRpjzRf5bTc,xAUkGxaLVfE';

		// ASYNC
		YTSearch({key: API_KEY, term: videoIds}, (videos) => {
			this.setState({ 
				videos: videos,
				selectedVideo: videos[0] // Default to first video
			 });
			//this.setState({ videos }); // ES6! when key and value are same this line is identical to line above
		});
	}

	render() {
		return (
			<div>
				<VideoDetail video={this.state.selectedVideo} />
				<VideoList 
					onVideoSelect={selectedVideo => this.setState({selectedVideo})}
					videos={this.state.videos} />
			</div>
		);
	}
}

// <App /> is now an instance of this

// Take this component's generated HTML and put it on the page (in the DOM)

export default VideoPlayer;
//ReactDOM.render(<App />, document.querySelector('.container'));



// WEBPACK FOOTER //
// ./app/components/section/video_player.js